// @flow
import { GoogleAnalytics } from './google-analytics';
import { FacebookPixel } from './facebook-pixel';
import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { type AnalyticsManager, type AnalyticsEventType } from '@tectonics/analytics';
import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type PlaceOrderErrorPayload } from '@tectonics/prs/outgoing-payment';

type initAnalyticsArgs = {|
  incomingPayment: IncomingPayment,
|};

export function initAnalytics({ incomingPayment }: initAnalyticsArgs): AnalyticsManager {
  const providers = [new GoogleAnalytics(), new FacebookPixel()];

  const initializedProviders = providers.filter(provider => {
    try {
      return provider.init(incomingPayment);
    } catch (e) {
      // Don't do anything
    }
  });

  const setUserInputValues = (userInputValues: UserInputValues) => {
    initializedProviders.forEach(provider => provider.setUserInputValues(userInputValues));
  };

  const setSubmitError = (submitError: ?PlaceOrderErrorPayload) => {
    initializedProviders.forEach(provider => provider.setSubmitError(submitError));
  };

  const event = (eventType: AnalyticsEventType) => {
    initializedProviders.forEach(provider => provider.event(eventType));
  };

  const eventOnce = (eventType: AnalyticsEventType,  incomingPayment: IncomingPayment) => {
    initializedProviders.forEach(provider => provider.eventOnce(eventType, incomingPayment));
  };

  return { setUserInputValues, setSubmitError, event, eventOnce };
}
